export class MedicalDevice{
  concernsMedicalDevice: boolean;
  followingManufacturerNoticeProof: string;
}
